module.exports = __webpack_public_path__ + "img/service-parts-display-parallax-honda.8f4f66cd.png";